const Limits = {
    POS_ORDER_LIMITS: 'POS Order Limits',
    ECOMMERCE_ORDER_LIMITS: 'Ecommerce Order Limits',
    BRANCH_LIMITS: 'Branch Limits',
    USER_LIMITS: 'User Limits',
};

export default Limits;